import React, { Component } from 'react';
import * as yup from "yup";
import { message, Select, TimePicker } from "antd";
import Script from 'react-load-script';
import _, { map } from 'lodash';
import moment from "moment-timezone";

import Header from '../../Common/Component/Header';
import Sidebar from '../../Common/Component/Sidebar';
import userimg from "../../../Assets/images/userimg.jpg";
import Loader from "../../Common/Component/Loader";
import {errorHandle} from "../../Common/errorHandle";

const { Option } = Select;

const skillValue = {
  isRegular: 'residential_regular',
  isInitialCleaning: 'residential_init_clean',
  petWasteService: 'pet_waste_station',
  petWasteInstall: 'pet_waste_station_install',
  commonAreaClean: 'common_area_cleaning'
};

const notificationType = {
  assignedToMe: "new_ticket",
  franchiseCustomer: "new_customer",
  franchiseLead: "new_lead",
  serviceCancellation: "service_cancellation",
};

let lastKey = '';

class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uuid: '',
      personalInfo: {
        image: '',
        name: '',
        phone_number: '',
        email: '',
        franchise: '',
        group: '',
        bio: '',
      },
      specificSetting: {
        startLocation: {},
        stopLocation: {},
        isRegular: false,
        isInitialCleaning: false,
        petWasteService: false,
        petWasteInstall: false,
        commonAreaClean: false,
      },
      workHours: [
        {
          key: 'Sunday',
          value: 'sun',
          from: '',
          to: '',
          checked: false
        },
        {
          key: 'Monday',
          value: 'mon',
          from: '',
          to: '',
          checked: false
        },
        {
          key: 'Tuesday',
          value: 'tues',
          from: '',
          to: '',
          checked: false
        },
        {
          key: 'Wednesday',
          value: 'wed',
          from: '',
          to: '',
          checked: false
        },
        {
          key: 'Thursday',
          value: 'thurs',
          from: '',
          to: '',
          checked: false
        },
        {
          key: 'Friday',
          value: 'fri',
          from: '',
          to: '',
          checked: false
        },
        {
          key: 'Saturday',
          value: 'sat',
          from: '',
          to: '',
          checked: false
        }
      ],
      singleWorkHour: {},
      notification: {
        assignedToMe: false,
        franchiseCustomer: false,
        franchiseLead: false,
        serviceCancellation: false
      },
      is_btn_active: false,
      errors: {},
      loader: false,
      franchiseData: {},
      userGroup: {},
      userDetail: {},
      notificationData: {},
      edited: false,
      defaultStartLocation: {},
      defaultStopLocation: {},
      is_profile_img: false,
      userRoles: {},
      logged_in_user_role: [],
      authUserFranchiseID:''
    }
    this.upload = null;
  }

  componentDidMount() {
    this.setState({ loader: true });
    const user = JSON.parse(localStorage.getItem("authUser")) ? JSON.parse(localStorage.getItem("authUser")).user : {}
    this.props.getFranchise(); // get franchise list
    this.props.getNotificationById({ user__uuid: user.uuid }); // get notification list
    this.props.getUserDetail('me'); // get user detail
    this.props.getUserRoles(); // get user role list

    // get logged in user roles
    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const logged_in_user_role = authUser?.user?.user_roles?.map(x => x.name)
    this.setState({logged_in_user_role})
    this.setState({
      authUserFranchiseID : authUser?.user?.associated_field_offices?.[0]?.uuid
    })
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { edited } = this.state;
    let user = JSON.parse(localStorage.getItem('authUser')) || null;
    let temp_user = user?.user || null;

    // errors
    if (Object.keys(nextProps?.errors).length > 0 && JSON.stringify(nextProps?.errors) !== JSON.stringify(this.props.errors)) {
      errorHandle(nextProps?.errors)
      this.setState({ edited: false });
      this.setState({ loader: false });
    }

    // get franchise list
    if (Object.keys(nextProps?.franchise).length > 0 && JSON.stringify(nextProps?.franchise) !== JSON.stringify(this.props.franchise)) {
      this.setState({ franchiseData: nextProps?.franchise });
      this.setState({ loader: false });
    }

    // get user group
    if (Object.keys(nextProps?.userGroup).length > 0 && JSON.stringify(nextProps?.userGroup) !== JSON.stringify(this.props.userGroup)) {
      this.setState({ userGroup: nextProps?.userGroup });
      this.setState({ loader: false });
    }

    // get user detail
    if (Object.keys(nextProps?.userDetail).length > 0 && JSON.stringify(nextProps?.userDetail) !== JSON.stringify(this.props.userDetail)) {

      temp_user = Object.assign(temp_user, { 'photo': nextProps?.userDetail?.photo, ...nextProps?.userDetail });
      user = Object.assign(user, { user: temp_user });

      localStorage.setItem('authUser', JSON.stringify(user));

      let authUser = JSON.parse(localStorage.getItem('authUser'))
      const logged_in_user_role = authUser?.user?.user_roles?.map(x => x.name)
      this.setState({logged_in_user_role})

      this.setUserDetail(nextProps?.userDetail);
      this.props.getUserGroup({field_office__uuid: nextProps?.userDetail?.staff_profile?.field_office?.uuid}); // get user group list
      if (edited) {
        message.success('Updated Successfully');
        this.setState({ edited: false });
      }
      this.setState({ loader: false });
    }

    // get notification list
    if (Object.keys(nextProps?.notifications).length > 0) {
      const notifications = nextProps?.notifications?.results || nextProps?.notifications;
      const assignedToMeIdx = notifications?.findIndex((item) => item.type === notificationType.assignedToMe);
      const customerIdx = notifications?.findIndex((item) => item.type === notificationType.franchiseCustomer);
      const leadIdx = notifications?.findIndex((item) => item.type === notificationType.franchiseLead);
      const cancellationIdx = notifications?.findIndex((item) => item.type === notificationType.serviceCancellation);
      let obj = {
        assignedToMe: assignedToMeIdx > -1 && notifications[assignedToMeIdx]?.email,
        franchiseCustomer: customerIdx > -1 && notifications[customerIdx]?.email,
        franchiseLead: leadIdx > -1 && notifications[leadIdx]?.email,
        serviceCancellation: cancellationIdx > -1 && notifications[cancellationIdx]?.email
      }
      this.setState({ notificationData: notifications, notification: obj, loader: false });

    }

    // get user group
    if (Object.keys(nextProps?.userRoles).length > 0 && JSON.stringify(nextProps?.userRoles) !== JSON.stringify(this.props.userRoles)) {
      this.setState({ userRoles: nextProps?.userRoles, loader: false  });
    }
  }

  // set user detail
  setUserDetail = (data) => {
    const { workHours } = this.state;
    let hours = [], hoursOfWork = data?.hours_of_work
    map(workHours, (stateHour) => {
      // ({day: hour?.value, start_time: hour?.from, end_time: hour?.to}))
      let idx = hoursOfWork?.findIndex((hour) => stateHour?.value === hour?.day);
      if (idx > -1) {
        hours.push({
          ...stateHour,
          from: hoursOfWork?.[idx]?.enable ? hoursOfWork?.[idx]?.start_time : '',
          to: hoursOfWork?.[idx]?.enable ? hoursOfWork?.[idx]?.end_time : '',
          checked: hoursOfWork?.[idx]?.enable
        });
      } else {
        hours.push({
          ...stateHour,
          from: "",
          to: "",
          checked: false
        });
      }
    });

    const cleaned = data?.phone_numbers?.[0]?.phone?.replace(/\D/g, '');

    let obj = {
      uuid: data?.uuid,
      personalInfo: {
        image: data?.photo || '',
        name: data?.first_name ? `${data?.first_name} ${data?.last_name}` : '',
        phone_number: this.formatPhoneNumber(cleaned) || '',
        email: data?.email || '',
        franchise: data?.staff_profile?.field_office?.uuid || '',
        group: data?.group?.uuid || '',
        bio: data?.description || '',
        role: data?.role?.length > 0 ? data.role : '',
      },
      specificSetting: {
        startLocation: data?.staff_profile?.start_location || {},
        stopLocation: data?.staff_profile?.stop_location || {},
        isRegular: data?.staff_profile?.skillset?.includes(skillValue?.isRegular) || false,
        isInitialCleaning: data?.staff_profile?.skillset?.includes(skillValue?.isInitialCleaning) || false,
        petWasteService: data?.staff_profile?.skillset?.includes(skillValue?.petWasteService) || false,
        petWasteInstall: data?.staff_profile?.skillset?.includes(skillValue?.petWasteInstall) || false,
        commonAreaClean: data?.staff_profile?.skillset?.includes(skillValue?.commonAreaClean) || false,
      },
      workHours: hours?.length > 0 ? [...hours] : [...workHours],
      defaultStartLocation: data?.staff_profile?.start_location || {},
      defaultStopLocation: data?.staff_profile?.stop_location || {}
    }
    this.setState({ ...obj }, () => {
      const { specificSetting } = this.state;
      if (!_.isEmpty(specificSetting?.startLocation)) {
        let startAddress = specificSetting?.startLocation?.address ? `${specificSetting?.startLocation?.address}` : '';
        startAddress += specificSetting?.startLocation?.city ? `, ${specificSetting?.startLocation?.city}` : '';
        startAddress += specificSetting?.startLocation?.state ? `, ${specificSetting?.startLocation?.state}` : '';
        startAddress += specificSetting?.startLocation?.zip_code ? `, ${specificSetting?.startLocation?.zip_code}` : '';
        if (this.refs['startLocation']) {
          this.refs['startLocation'].value = startAddress;
        }
      }
      if (!_.isEmpty(specificSetting?.stopLocation)) {
        let stopAddress = specificSetting?.stopLocation?.address ? `${specificSetting?.stopLocation?.address}` : '';
        stopAddress += specificSetting?.stopLocation?.city ? `, ${specificSetting?.stopLocation?.city}` : '';
        stopAddress += specificSetting?.stopLocation?.state ? `, ${specificSetting?.stopLocation?.state}` : '';
        stopAddress += specificSetting?.stopLocation?.zip_code ? `, ${specificSetting?.stopLocation?.zip_code}` : '';

        if (this.refs['stopLocation']) {
          this.refs['stopLocation'].value = stopAddress;
        }
      }
    });
  };

  // get base 64 string
  getBase64String = (file = {}, cb) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = function () {
      cb(reader.result);
    }
  };

  // on user image change
  onImageChange = (e) => {
    const { personalInfo } = this.state;
    let file = e?.target?.files?.[0];
    if (file?.size > (5 * 1048576)) {
      message.error('Image size should be less than 5MB');
    } else {
      file && this.getBase64String(file, (result) => {
        Object.assign(personalInfo, { image: result });
        this.setState({ personalInfo, is_profile_img: true })
      });
    }
  };

  // on object value change
  onObjectValueChange = (e, name, type) => {
    const { personalInfo, specificSetting, defaultStartLocation, defaultStopLocation } = this.state;
    let data = name === 'personalInfo' ? personalInfo : specificSetting;
    const value = type === 'bool' ? e.target.checked : e.target.value;
    Object.assign(data, { [e.target.name]: value });
    if (e.target.name === 'group') {
      const obj = {
        ...specificSetting,
        startLocation: defaultStartLocation,
        stopLocation: defaultStopLocation
      }
      this.setState({ specificSetting: obj });
    }
    this.setState({ [name]: data })
  };

  //on Phone number changed
  onPhoneNumberChange = (e) => {
    const { personalInfo } = this.state;
    const pattern = /[0-9]/;
    let cleaned = e.target.value?.replace(/\D/g, '');

    if (cleaned?.length > 10) return

    if (lastKey === "Backspace") {
      let value = personalInfo?.phone_number; //?.replace(/\D/g, '');
      value = value?.substr(0, personalInfo?.phone_number?.length - 1);
      Object.assign(personalInfo, { [e.target.name]: value });
      this.setState({ personalInfo })
    } else if (pattern.test(cleaned)) {
      Object.assign(personalInfo, { [e.target.name]: this.formatPhoneNumber(cleaned) });
      this.setState({ personalInfo })
    }
  };

  // compare time
  onTimeDifference = (startTime, endTime) => {
    // compare both the time
    return moment(startTime, 'h:mm A').isBefore(moment(endTime, 'h:mm A'))
  };

  // on work hour change
  onWorkHourChange = (e, index, type) => {
    const { workHours } = this.state;
    workHours[index][e.target.name] = type === 'bool' ? e.target.checked : e.target.value
    this.setState({ workHours, singleWorkHour: workHours[index] });
  };

  // on notification change
  onNotificationChanged = (e) => {
    const { notification } = this.state;

    this.setState({
      notification: Object.assign(notification, { [e.target.name]: e.target.checked })
    });
  };

  // format phone number
  formatPhoneNumber = (phone) => {
    if (phone?.length <= 3) {
      return phone
    } else if (phone?.length > 3 && phone?.length <= 6) {
      return phone.substr(0, 3) + ' ' + phone.substr(3, 3);
    } else if (phone?.length > 6) {
      return phone.substr(0, 3) + ' ' + phone.substr(3, 3) + ' ' + phone.substr(6);
    }
  }

  // Google Map Place API
  handleScriptLoad = () => {

    // Declare Options For Autocomplete
    const options = { componentRestrictions: { country: 'us' } };

    // Initialize Google Autocomplete
    /*global google*/ // To disable any eslint 'google not defined' errors
    const newStartAutoComplete = new google.maps.places.Autocomplete(
      document.getElementById('google_address_start'),
      options,
    );

    const newStopAutoComplete = new google.maps.places.Autocomplete(
      document.getElementById('google_address_stop'),
      options,
    );

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components and formatted
    // address.
    newStartAutoComplete.setFields(['address_components', 'formatted_address']);
    newStopAutoComplete.setFields(['address_components', 'formatted_address']);

    // Fire Event when a suggested name is selected
    newStartAutoComplete.addListener('place_changed', this.handleStartPlaceSelect);
    newStopAutoComplete.addListener('place_changed', this.handleStopPlaceSelect);

    this.setState({
      startAutocomplete: newStartAutoComplete,
      stopAutocomplete: newStopAutoComplete,
    })
  };

  // on start place change
  handleStartPlaceSelect = () => {
    const { startAutocomplete, specificSetting } = this.state;
    const addressObject = startAutocomplete?.getPlace();
    let obj = {};
    map(addressObject?.address_components, (item) => {

      if (item?.types?.includes('route') || item?.types?.includes('administrative_area_level_2')) {
        obj = Object.assign(obj, { 'address': item.short_name })
      }
      if (item?.types?.includes('route')) {
        obj = Object.assign(obj, { 'route': item.short_name })
      }
      if (item?.types?.includes('street_number')) {
        obj = Object.assign(obj, { 'street_number': item.short_name })
      }
      if (item?.types?.includes('administrative_area_level_1')) {
        obj = Object.assign(obj, { 'state': item.short_name })
      }
      if (item?.types?.includes('locality')) {
        obj = Object.assign(obj, { 'city': item.long_name })
      }
      if (item?.types?.includes('postal_code')) {
        obj = Object.assign(obj, { 'zip_code': item.short_name })
      }
    });
    const locationObj = { ...specificSetting, startLocation: obj };
    this.setState({ specificSetting: locationObj }, () => {
      if (!obj?.address || !obj?.state || !obj.city || !obj.zip_code) {
        message.error('Please enter valid start location');
      }
      // this.validate()
    });
  }

  // on stop place change
  handleStopPlaceSelect = () => {
    const { stopAutocomplete, specificSetting } = this.state;
    const addressObject = stopAutocomplete?.getPlace();
    let obj = {};
    map(addressObject?.address_components, (item) => {

      if (item?.types?.includes('route') || item?.types?.includes('administrative_area_level_2')) {
        obj = Object.assign(obj, { 'address': item.short_name })
      }
      if (item?.types?.includes('route')) {
        obj = Object.assign(obj, { 'route': item.short_name })
      }
      if (item?.types?.includes('street_number')) {
        obj = Object.assign(obj, { 'street_number': item.short_name })
      }
      if (item?.types?.includes('administrative_area_level_1')) {
        obj = Object.assign(obj, { 'state': item.short_name })
      }
      if (item?.types?.includes('locality')) {
        obj = Object.assign(obj, { 'city': item.long_name })
      }
      if (item?.types?.includes('postal_code')) {
        obj = Object.assign(obj, { 'zip_code': item.short_name })
      }
    });
    const locationObj = { ...specificSetting, stopLocation: obj };
    this.setState({ specificSetting: locationObj }, () => {
      if (!obj?.address || !obj?.state || !obj.city || !obj.zip_code) {
        message.error('Please enter valid stop location')
      }
      // this.validate()
    });
  }

  // validate required fields
  validate = () => {
    const {
      personalInfo,
      specificSetting,
      userGroup,
      workHours
    } = this.state;
    const REGULAR_EXPRESSION_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const grp = userGroup?.results?.filter((item) => item.uuid === personalInfo?.group);
    const isField = grp?.[0]?.name?.toLowerCase()?.includes('field') || personalInfo?.role?.[0].includes("field");

    const schema = yup.object().shape({
      isField: yup.bool().required(''),
      personalInfo: yup.object().shape({
        name: yup.string().required("Name is required"),
        phone_number: yup.string().required("Phone Number is required").min(12, 'Invalid phone number'),
        email: yup.string().required("Email is required").matches(REGULAR_EXPRESSION_EMAIL, "Invalid Email Address"),
        franchise: yup.string().required("Franchise is required").notOneOf(['Select'], 'Franchise is required'),
        group: yup.string().required("Group is required").notOneOf(['Select'], 'Group is required'),
        role: yup.string().required("Role is required").notOneOf(['Select'], 'Role is required'),
        // bio: yup.string().required("Bio is required"),
      }),
      specificSetting: yup.object().shape({
        startLocation: yup.object().shape({
          address: yup.string().when("isField", { is: () => isField, then: yup.string().required('Invalid Start Location address') }),
          city: yup.string().when("isField", { is: () => isField, then: yup.string().required('Invalid Start Location city') }),
          state: yup.string().when("isField", { is: () => isField, then: yup.string().required('Invalid Start Location state') }),
          zip_code: yup.string().when("isField", { is: () => isField, then: yup.string().required('Invalid Start Location zip code') }),
        }),
        stopLocation: yup.object().shape({
          address: yup.string().when("isField", { is: () => isField, then: yup.string().required('Invalid Stop Location address') }),
          city: yup.string().when("isField", { is: () => isField, then: yup.string().required('Invalid Start Location city') }),
          state: yup.string().when("isField", { is: () => isField, then: yup.string().required('Invalid Start Location state') }),
          zip_code: yup.string().when("isField", { is: () => isField, then: yup.string().required('Invalid Start Location zip code') }),
        })
      }),
      workHours: yup.array(yup.object().shape({
        from: yup.string(),
        to: yup.string().test("compare", "Invalid time", function (to) {
          if (this.parent.from && to) {
            const start = moment(this.parent.from, 'hh:mm A').format('HH:mm')
            const end = moment(to, 'hh:mm A').format('HH:mm')
            console.log(this.parent.key, moment(start, 'HH:mm').isBefore(moment(end, 'HH:mm')))
            return moment(start, 'HH:mm').isBefore(moment(end, 'HH:mm'))
          }
          return true
        })
      }))
    });

    const data = {
      isField,
      personalInfo,
      specificSetting,
      workHours
    }

    setTimeout(() => {
      schema.validate(data, { abortEarly: false }).then(() => {
        this.setState({ is_btn_active: true, errors: {} });
        this.onSaveChange()
      }).catch((error) => {
        let err_data = {};
        map(error.inner, (item) => { err_data[item.path] = item.message })
        console.log(err_data)
        this.setState({ errors: err_data, is_btn_active: false })
      });
    }, 200);
  };

  // on save change
  onSaveChange = () => {
    const {
      personalInfo,
      specificSetting,
      workHours,
      notification,
      notificationData,
      userGroup,
      franchiseData,
      is_profile_img
    } = this.state;
    this.setState({ loader: true });
    const grp = userGroup?.results?.filter((item) => item.uuid === personalInfo?.group)
    const selectedFranchise = franchiseData?.results?.filter((item) => item.uuid === personalInfo?.franchise)
    const hours_of_work = [];
    map(workHours, (hour) => {
      if (hour?.checked && hour?.from && hour?.to && this.onTimeDifference(hour?.from, hour?.to)) {
        hours_of_work.push({ day: hour?.value, start_time: moment(hour?.from, 'hh:mm A').format('HH:mm'), end_time: moment(hour?.to, 'hh:mm A').format('HH:mm'), enable: true });
      } else {
        hours_of_work.push({ day: hour?.value, start_time: null, end_time: null, enable: false });
      }
    });

    let skillset = [];
    specificSetting?.isRegular && skillset.push(skillValue?.isRegular);
    specificSetting?.isInitialCleaning && skillset.push(skillValue?.isInitialCleaning);
    specificSetting?.petWasteService && skillset.push(skillValue?.petWasteService);
    specificSetting?.petWasteInstall && skillset.push(skillValue?.petWasteInstall);
    specificSetting?.commonAreaClean && skillset.push(skillValue?.commonAreaClean);

    // notification
    const assignedToMeIdx = notificationData?.findIndex((item) => item.type === notificationType.assignedToMe);
    const customerIdx = notificationData?.findIndex((item) => item.type === notificationType.franchiseCustomer);
    const leadIdx = notificationData?.findIndex((item) => item.type === notificationType.franchiseLead);
    const cancellationIdx = notificationData?.findIndex((item) => item.type === notificationType.serviceCancellation);

    let notifications = [];
    notifications.push({ ...notificationData[assignedToMeIdx], email: notification?.assignedToMe || false });
    notifications.push({ ...notificationData[customerIdx], email: notification?.franchiseCustomer || false });
    notifications.push({ ...notificationData[leadIdx], email: notification?.franchiseLead || false });
    notifications.push({ ...notificationData[cancellationIdx], email: notification?.serviceCancellation || false });

    let obj = {
      first_name: personalInfo?.name?.split(' ')?.[0],
      last_name: personalInfo?.name?.split(' ')?.[1],
      email: personalInfo?.email,
      description: personalInfo?.bio,
      phone_numbers: [{
        phone: personalInfo?.phone_number,
        primary: true,
        can_send_sms: false
      }],
      group: {
        name: grp?.[0]?.name
      },
      hours_of_work: !grp?.[0]?.name?.toLowerCase()?.includes('manager') ? hours_of_work : [],
      franchise_uuid: personalInfo?.franchise,
      role: personalInfo?.role
    };

    if (grp?.[0]?.name?.toLowerCase()?.includes('field')) {
      if (!specificSetting?.startLocation?.geo_location) delete specificSetting?.startLocation?.geo_location
      if (!specificSetting?.stopLocation?.geo_location) delete specificSetting?.stopLocation?.geo_location
      obj = {
        ...obj,
        staff_profile: {
          field_office: {
            name: selectedFranchise?.[0]?.name,
            address: selectedFranchise?.[0]?.address,
          },
          start_location: (specificSetting?.startLocation?.street_number && specificSetting?.startLocation?.route) ? { ...specificSetting?.startLocation, address: `${specificSetting?.startLocation?.street_number} ${specificSetting?.startLocation?.route}` } : specificSetting?.startLocation,
          stop_location: (specificSetting?.stopLocation?.street_number && specificSetting?.stopLocation?.route) ? { ...specificSetting?.stopLocation, address: `${specificSetting?.stopLocation?.street_number} ${specificSetting?.stopLocation?.route}` } : specificSetting?.stopLocation,
          skillset: skillset?.length > 0 ? skillset : null
        }
      }
    }

    if (is_profile_img) {
      obj = {
        ...obj,
        photo: personalInfo?.image,
      }
    }
    console.log("Object : ", obj);
    this.props.editUserDetail(obj, "me", () => this.props.getUserDetail('me'));
    this.props.updateNotification(notifications);
    this.setState({ edited: true, is_profile_img: false });
  };

  // render specific setting
  renderSpecificSetting = () => {
    const { specificSetting, errors, userGroup, personalInfo } = this.state;
    const grp = userGroup?.results?.filter((item) => item.uuid === personalInfo?.group);
    let startAddress = '', stopAddress = '';
    if (!_.isEmpty(specificSetting?.startLocation)) {
      startAddress = specificSetting?.startLocation?.address ? `${specificSetting?.startLocation?.address}` : '';
      startAddress += specificSetting?.startLocation?.city ? `, ${specificSetting?.startLocation?.city}` : '';
      startAddress += specificSetting?.startLocation?.state ? `, ${specificSetting?.startLocation?.state}` : '';
      startAddress += specificSetting?.startLocation?.zip_code ? `, ${specificSetting?.startLocation?.zip_code}` : '';
    }
    if (!_.isEmpty(specificSetting?.stopLocation)) {
      stopAddress = specificSetting?.stopLocation?.address ? `${specificSetting?.stopLocation?.address}` : '';
      stopAddress += specificSetting?.stopLocation?.city ? `, ${specificSetting?.stopLocation?.city}` : '';
      stopAddress += specificSetting?.stopLocation?.state ? `, ${specificSetting?.stopLocation?.state}` : '';
      stopAddress += specificSetting?.stopLocation?.zip_code ? `, ${specificSetting?.stopLocation?.zip_code}` : '';
    }

    return (
      <div className="specific-fitem">
        <h6>{`${grp?.[0]?.name || ''} Specific Settings`}</h6>
        <div className="fitem">
          <label htmlFor="location">Start and Stop Location</label>
          <div>
            <Script
              url={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_PLACE_API_KEY}&libraries=places`}
              onLoad={() => window.requestAnimationFrame(this.handleScriptLoad)}
            />

            <input
              autoComplete="off"
              type="text"
              ref="startLocation"
              className={'form-control mb-10'}
              placeholder={startAddress ? startAddress : 'Enter start location'}
              name="google_address_start"
              id="google_address_start"
              onChange={(e) => {
                if (!e.target.value) {
                  const obj = {
                    ...specificSetting,
                    startLocation: { address: '', state: '', city: '', zipcode: '' }
                  }
                  this.setState({
                    specificSetting: obj
                  })
                }
              }}
            />
            {errors?.['specificSetting.startLocation.address'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['specificSetting.startLocation.address']}</label> : ''}

            <input
              autoComplete="off"
              type="text"
              ref="stopLocation"
              className={'form-control'}
              placeholder={stopAddress ? stopAddress : 'Enter stop location'}
              name="google_address_stop"
              id="google_address_stop"
              onChange={(e) => {
                if (!e.target.value) {
                  const obj = {
                    ...specificSetting,
                    stopLocation: { address: '', state: '', city: '', zipcode: '' }
                  }
                  this.setState({
                    specificSetting: obj
                  })
                }
              }}
            />
          </div>
          {errors?.['specificSetting.stopLocation.address'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['specificSetting.stopLocation.address']}</label> : ''}
        </div>
        <div className="fitem inline-check-list gray-check mt-20">
          <div className="fitem-check">
            <input
              type="checkbox"
              className="fitem-ck-input"
              id="checkbox"
              name="isRegular"
              checked={specificSetting?.isRegular}
              onChange={(e) => this.onObjectValueChange(e, 'specificSetting', 'bool')} />
            <label htmlFor="checkbox" className="fitem-ck-txt">Residential Regular</label>
          </div>
          <div className="fitem-check">
            <input
              type="checkbox"
              className="fitem-ck-input"
              id="checkbox1"
              name="isInitialCleaning"
              checked={specificSetting?.isInitialCleaning}
              onChange={(e) => this.onObjectValueChange(e, 'specificSetting', 'bool')} />
            <label htmlFor="checkbox1" className="fitem-ck-txt">Residential Initial Cleaning</label>
          </div>
          <div className="fitem-check">
            <input
              type="checkbox"
              className="fitem-ck-input"
              id="checkbox2"
              name="petWasteService"
              checked={specificSetting?.petWasteService}
              onChange={(e) => this.onObjectValueChange(e, 'specificSetting', 'bool')} />
            <label htmlFor="checkbox2" className="fitem-ck-txt">Pet Waste Station Service</label>
          </div>
          <div className="fitem-check">
            <input
              type="checkbox"
              className="fitem-ck-input"
              id="checkbox3"
              name="petWasteInstall"
              checked={specificSetting?.petWasteInstall}
              onChange={(e) => this.onObjectValueChange(e, 'specificSetting', 'bool')} />
            <label htmlFor="checkbox3" className="fitem-ck-txt">Pet Waste Station Installation</label>
          </div>
          <div className="fitem-check">
            <input
              type="checkbox"
              className="fitem-ck-input"
              id="checkbox4"
              name="commonAreaClean"
              checked={specificSetting?.commonAreaClean}
              onChange={(e) => this.onObjectValueChange(e, 'specificSetting', 'bool')}
            />
            <label htmlFor="checkbox4" className="fitem-ck-txt">Common Area Cleaning Service</label>
          </div>
        </div>
      </div>
    )
  };

  // render form of personal info
  renderForm = () => {
    const { personalInfo, errors, userGroup, franchiseData, userRoles, logged_in_user_role } = this.state;
    const grp = userGroup?.results?.filter((item) => item.uuid === personalInfo?.group);
    const is_buss_dev_franchise = logged_in_user_role?.includes('business_dev_franchiese')
    const is_acc_franchise = logged_in_user_role?.includes('accounting_franchiese')
    const is_call_center = logged_in_user_role?.includes('service_rep')
    const is_franchise_owner = logged_in_user_role?.includes(`franchise_owner`)

    return (
      <div className="inner-block-row">
        <div className="form-group">
          <div className="fitem">
            <label htmlFor="name">Name</label>
            <input
              disabled={(is_buss_dev_franchise || is_acc_franchise)}
              name="name"
              type="text"
              placeholder={"Name"}
              value={personalInfo?.name}
              onChange={(e) => this.onObjectValueChange(e, 'personalInfo')}
            />
            {errors?.['personalInfo.name'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['personalInfo.name']}</label> : ''}
          </div>
          <div className="fitem phnum">
            <label htmlFor="phone_number">Phone number</label>
            <span>+1</span>
            <input
              disabled={(is_buss_dev_franchise || is_acc_franchise)}
              name="phone_number"
              type="text"
              placeholder={"Phone Number"}
              maxLength={"12"}
              max='12'
              value={personalInfo?.phone_number}
              onKeyDown={(e) => lastKey = e.key}
              onChange={(e) => this.onPhoneNumberChange(e)}
            />
            {errors?.['personalInfo.phone_number'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['personalInfo.phone_number']}</label> : ''}
          </div>
          <div className="fitem">
            <label htmlFor="email">Email Address</label>
            <input
              disabled={(is_buss_dev_franchise || is_acc_franchise)}
              name="email"
              type="text"
              placeholder={"Email"}
              value={personalInfo?.email}
              onChange={(e) => this.onObjectValueChange(e, 'personalInfo')}
            />
            {errors?.['personalInfo.email'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['personalInfo.email']}</label> : ''}
          </div>
          <div className="fitem">
            <label htmlFor="franchise">Franchise</label>
            <Select
              disabled={(is_buss_dev_franchise || is_acc_franchise || is_franchise_owner)}
              name={"franchise"}
              placeholder={"Franchise"}
              value={personalInfo?.franchise || undefined}
              onChange={(e) => {
                this.setState({loader: true})
                this.onObjectValueChange({ target: { value: e, name: 'franchise' } }, 'personalInfo')
                this.onObjectValueChange({ target: { value: '', name: 'group' } }, 'personalInfo')
                this.props.getUserGroup({field_office__uuid: e || '' });
              }}
            >
              {franchiseData?.results?.map((item, index) => <Option key={`franchise${index}`} value={item?.uuid}>{item?.name}</Option>)}
            </Select>
            {errors?.['personalInfo.franchise'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['personalInfo.franchise']}</label> : ''}
          </div>
          <div className="fitem">
            <label htmlFor="group">Group</label>
            <Select
              showSearch
              showArrow={true}
              filterOption={false}
              notFoundContent={null}
              disabled={(is_buss_dev_franchise || is_acc_franchise)}
              name={"group"}
              placeholder={"Group"}
              value={personalInfo?.group || undefined}
              onSearch={(e) => {
                this.props.getUserGroup({search: e, field_office__uuid: personalInfo?.franchise || '' });
              }}
              onBlur={() => {
                this.props.getUserGroup({field_office__uuid: personalInfo?.franchise || '' });
              }}
              onChange={(e) => this.onObjectValueChange({ target: { value: e, name: 'group' } }, 'personalInfo')}
            >
              {userGroup?.results?.filter(item => item.status === "active").map((item, index) => <Option key={`group${index}`} value={item?.uuid}>{item?.name}</Option>)}
            </Select>
            {errors?.['personalInfo.group'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['personalInfo.group']}</label> : ''}
          </div>
          <div className="fitem">
            <label htmlFor="">Roles</label>
            <Select
              disabled={(is_buss_dev_franchise || is_acc_franchise || is_call_center || is_franchise_owner || personalInfo?.franchise===this.state.authUserFranchiseID)}
              value={personalInfo.role || undefined}
              style={{ 'width': '100%' }}
              placeholder={"Roles"}
              onChange={(e) => {
                let { personalInfo } = this.state
                let role = [];
                role.push(e);
                personalInfo = Object.assign(personalInfo, { role });
                this.setState({ personalInfo })
              }}
            >
              {map(userRoles?.results, (item, i) => {
                if (item?.name !== 'commercial_customer' && item?.name !== 'lead' && item?.name !== 'customer' && item?.name !== 'commercial_lead') {
                  return (
                    <Option key={i} value={item.name}>{item.display_name}</Option>
                  )
                }
              })}
            </Select>
            {errors['personalInfo.role'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['personalInfo.role']}</label> : ''}
          </div>
          {(grp?.[0]?.name?.toLowerCase()?.includes('field') || personalInfo?.role?.[0].includes("field")) && this.renderSpecificSetting()}
        </div>
      </div>
    )
  };

  // render work hour
  renderWorkHours = (item, index) => {
    const { errors, logged_in_user_role } = this.state;
    const is_buss_dev_franchise = logged_in_user_role?.includes('business_dev_franchiese')
    const is_acc_franchise = logged_in_user_role?.includes('business_dev_franchiese')

    return (
      <div className="fitem inline-check-list gcheck" key={`hours${index}`}>
        <div className="fitem-check flex mb-10 ai-center" key={`${item?.key}${index}`}>
          <div className="hours-week">
            <input
              disabled={(is_buss_dev_franchise || is_acc_franchise)}
              type="checkbox"
              className="fitem-ck-input"
              id={`Week${index}`}
              name={'checked'}
              checked={item?.checked}
              onChange={(e) => this.onWorkHourChange(e, index, 'bool')} />
            <label htmlFor={`Week${index}`} className="fitem-ck-txt mb-0">{item.key}</label>
          </div>
          <div className="flex">
            <div className="fitem">
              <TimePicker
                format="h:mm A"
                placeholder="From"
                ref={`from${index}`}
                disabled={!item.checked}
                minuteStep={15}
                use12Hours
                value={item.from === "" ? null : moment(item.from, 'h:mm A')}
                allowClear={false}
                suffixIcon={<i className="las la-angle-down"></i>}
                onChange={(time, timeString) => this.onWorkHourChange({ target: { value: timeString, name: 'from' } }, index)}
              />
            </div>
            <div className="fitem">
              <TimePicker
                format="h:mm A"
                placeholder="To"
                ref={`to${index}`}
                disabled={!item.checked}
                minuteStep={15}
                use12Hours
                value={item.to === "" ? null : moment(item.to, 'h:mm A')}
                allowClear={false}
                suffixIcon={<i className="las la-angle-down"></i>}
                onChange={(time, timeString) => this.onWorkHourChange({ target: { value: timeString, name: 'to' } }, index)}
              />
              {errors?.[`workHours[${index}].to`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`workHours[${index}].to`]}</label> : ''}
            </div>
          </div>
        </div>
      </div>
    )
  };

  render() {
    const {
      personalInfo,
      workHours,
      notification,
      errors,
      userGroup,
      loader,
      logged_in_user_role
    } = this.state;
    const grp = userGroup?.results?.filter((item) => item.uuid === personalInfo?.group);
    const isManager = grp?.[0]?.name?.toLowerCase()?.includes('manager'); //personalInfo?.group?.includes('manager');
    const is_buss_dev_franchise = logged_in_user_role?.includes('business_dev_franchiese')
    const is_acc_franchise = logged_in_user_role?.includes('accounting_franchiese')

    return (
      <div id="wrapper">
        <div className="content-area">
          {/* Header */}
          <Header placeholder={'Search acc number, customer address or contact details'} disabled={true} />

          {/* Sidebar */}
          <Sidebar />

          <div className="block-row settings-page">
            <div className="container">
              {loader && <Loader />}
              <div className="aside-area pt-0">
                <div className="main">
                  <div className="card-row flex">
                    <div className="card-half">
                      <div className="flex ai-center flex-start">
                        <div className="profile-wrap user-profile">
                          <figure>
                            <img src={personalInfo?.image || userimg} alt="user" />
                          </figure>
                        </div>
                        <input
                          name={"image"}
                          type="file"
                          ref={(ref) => this.upload = ref}
                          style={{ "display": "none" }}
                          onChange={(e) => this.onImageChange(e)}
                        />
                        <div className="action-btn">
                          <button
                            type="button"
                            className={`btn ${(is_buss_dev_franchise || is_acc_franchise) ? 'disabled' : 'btn-bdr'} btn-xs mb-20`}
                            onClick={() => this.upload.click()}
                            disabled={(is_buss_dev_franchise || is_acc_franchise)}
                          >
                            Replace
                          </button>
                          <button type="button" className={`btn ${(is_buss_dev_franchise || is_acc_franchise) ? 'disabled' : 'btn-bdr btn-danger'} btn-xs mb-20`}
                            disabled={(is_buss_dev_franchise || is_acc_franchise)}
                            onClick={() => {
                              this.setState({ is_profile_img: true })
                              this.onObjectValueChange({ target: { name: 'image', value: '' } }, 'personalInfo')
                            }}
                          >Remove</button>
                        </div>
                      </div>
                      {this.renderForm()}
                    </div>
                    <div className="card-half">
                      <h4>{`User's Bio`}</h4>
                      <blockquote className="horiz">
                        <b>The customer will see this information about you!</b>
                        <p className="m-0">
                          As a field tech, customers will see who has serviced their property;
                          and as customer care rep, when you reply to tickets, customers will know who they are talking to!
                        </p>
                      </blockquote>
                      <div className="fitem  mb-30">
                        <label className="spl" htmlFor="bio">A little about me</label>
                        <textarea rows="4"
                          name="bio"
                          type="text"
                          placeholder={"A little about me"}
                          disabled={(is_buss_dev_franchise || is_acc_franchise)}
                          value={personalInfo?.bio}
                          onChange={(e) => this.onObjectValueChange(e, 'personalInfo')}
                        >
                        </textarea>
                        {errors?.bio && <label className="error">{errors?.bio}</label>}
                      </div>
                      {
                        !isManager &&
                        <div className="hours-work-wrap">
                          <h5>Hours of Work</h5>
                          {workHours.map((item, index) => this.renderWorkHours(item, index))}
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <aside className="white">
                  <div className="card">
                    <div className="card-title">
                      <h5>Notification Preferences</h5>
                    </div>
                    <div className="card-body">
                      <div className="fitem inline-check-list rcheck gcheck">
                        <div className="fitem-check">
                          <label htmlFor="checkbox" className="fitem-ck-txt text-right">Email</label>
                        </div>
                        <div className="fitem-check">
                          <input
                            type="checkbox"
                            className="fitem-ck-input"
                            id={'notification1'}
                            name={'assignedToMe'}
                            checked={notification?.assignedToMe}
                            disabled={(is_buss_dev_franchise || is_acc_franchise)}
                            onChange={(e) => this.onNotificationChanged(e)} />
                          <label htmlFor={"notification1"} className="fitem-ck-txt">New ticket assigned to me</label>
                        </div>
                        <div className="fitem-check">
                          <input
                            type="checkbox"
                            className="fitem-ck-input"
                            id={'notification2'}
                            name={'franchiseCustomer'}
                            checked={notification?.franchiseCustomer}
                            disabled={(is_buss_dev_franchise || is_acc_franchise)}
                            onChange={(e) => this.onNotificationChanged(e)} />
                          <label htmlFor={"notification2"} className="fitem-ck-txt">New franchise customer</label>
                        </div>
                        <div className="fitem-check">
                          <input
                            type="checkbox"
                            className="fitem-ck-input"
                            id={'notification3'}
                            name={'franchiseLead'}
                            checked={notification?.franchiseLead}
                            disabled={(is_buss_dev_franchise || is_acc_franchise)}
                            onChange={(e) => this.onNotificationChanged(e)} />
                          <label htmlFor={"notification3"} className="fitem-ck-txt">New franchise lead</label>
                        </div>
                        <div className="fitem-check">
                          <input
                            type="checkbox"
                            className="fitem-ck-input"
                            id={'notification4'}
                            name={'serviceCancellation'}
                            checked={notification?.serviceCancellation}
                            disabled={(is_buss_dev_franchise || is_acc_franchise)}
                            onChange={(e) => this.onNotificationChanged(e)} />
                          <label htmlFor={"notification4"} className="fitem-ck-txt">Service Cancellation</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </aside>
              </div>
            </div>
          </div>
          <div className="btn-submit">
            <button
              // type="button"
              disabled={(is_buss_dev_franchise || is_acc_franchise)}
              className={`btn ${(is_buss_dev_franchise || is_acc_franchise) ? 'disabled' : 'btn-warning'}`}
              onClick={() => this.validate()}>
              Save Changes
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default Settings;
